import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ProjectShareInterface } from "../../../middleware/interfaces/project/project-share-interface";

export const ProjectShare = {
  Share: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const projectShareData: ProjectShareInterface = state.data;
      const url = "./php/project/project-sharer-proxy.php";
      await axios
        .post(url, projectShareData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
